var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row content-block"},[_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.ru)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }